<template>
    <div class="g-table-wrapper">
        <div class="table-title">
            <d-tooltip identifier="oekonomi.unbilledProjects" placement="left" />
            Afsluttede opgaver, der ikke er fakturerede
        </div>

        <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="searchOptions"
            :pagination-options="paginationOptions"
            :sort-options="sortOptions"
            :styleClass="styleClass"
            v-if="!loading"
        >
            <div slot="emptystate">
                Ingen data ...
            </div>
            <template slot="table-row" slot-scope="props">
                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                    {{ props.row.coverage_percent | rounded }} 
                    <div
                        v-if="props.row.coverage_percent !== null"
                        class="coverage-indicator"
                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                    />
                </div>
                <div class="coverage-cell" v-else-if="props.column.field == 'status.name'">
                    {{ props.row.status.name }}
                    <div class="coverage-indicator status" :style="'background:#' + props.row.status.color + ';'" />
                </div>
                <div v-else-if="props.column.field == 'case_number'" class="table-column__ordernumber" style="text-align:left;">
                    {{ props.row.case_number }}
                </div>
                <div v-else-if="props.column.field == 'description'" class="table-column__description" :title="props.row.description">
                    <budget-tooltip :project="props.row" v-if="props.row.calculation_price > 0" />
                    {{ props.row.description ? props.row.description : '-' }}
                </div>
                <div v-else-if="props.column.field == 'customer.name'" class="table-column__customer" :title="props.row.customer ? props.row.customer.name : '-'">
                    {{ props.row.customer ? props.row.customer.name : '-' }}
                </div>
                <div v-else-if="props.column.field == 'type.name'" class="table-column__type" :title="props.row.type ? props.row.type.name : '-'">
                {{ props.row.type ? props.row.type.name : '-' }}
                </div>
                <div v-else-if="props.column.field == 'action'" class="g-table__action" @click="openExternalLink(props.row.external_id)">
                    <i class="fad fa-eye" />
                </div>
                <div v-else-if="props.column.field == 'start_date'">
                    {{ props.row.start_date | moment("DD. MMM YYYY") }}
                </div>
                <div v-else-if="props.column.field == 'type.name'" class="table-column__description" :title="props.row.type ? props.row.type.name : '-'">
                    {{ props.row.type ? props.row.type.name : '-' }}
                </div>
                <div v-else-if="props.column.field == 'minuba_external_id'">
                    <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                        <i class="fas fa-eye"></i>
                    </a>
                </div>
                <div v-else :title="props.formattedRow[props.column.field]">
                    {{ props.formattedRow[props.column.field] }}
                </div>
            </template>
        </vue-good-table>   

        <box-loading height="350" v-else />
    </div>
</template>

<script>
import shared from './shared.js'
import * as projectService from '@/services/projectService'

export default {
    data () {
        return {
            explanation: 'Denne tabel viser alle opgaver med en status, der angiver at den er afsluttet, men hvor der endnu ikke ligger en eller flere fakturaer tilknyttet opgaven. Hvis opgaven <b>er</b> blevet faktureret, bør du undersøge om fakturaen er tilknyttet opgaven i dit ordrestyrings-program.',
            loading: true,
            columns: [
                { label: 'Ordre', field: 'case_number', type: 'number' },
                { label: 'Kunde', field: 'customer.name', type: 'string' },
                { label: 'Opgave', field: 'description', type: 'string' },
                { label: 'Opgavetype', field: 'type.name', type: 'string' },
                { label: 'Startdato', field: 'start_date', type: 'string' },
                { label: 'Status', field: 'status.name', type: 'string' }
            ],
            rows: [],
            searchOptions: {
                ...shared.searchOptions
            },
            paginationOptions: {
                ...shared.paginationOptions
            },
            sortOptions: {
                ...shared.sortOptions,
                initialSortBy: {
                    field: 'start_date',
                    type: 'asc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    created () {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' })
        }
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.$emit('finishedLoading', null)
            let params = {
                'filter[status]': 'unbilled',
                // 'filter[no_invoice]': true,
                'filter[visible]': true,
                include: 'type,customer,status',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid
            }
            projectService.find(params, (response) => {
                this.rows = response.data
                this.$emit('finishedLoading', this.rows.length)
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// noInvoice.vue?6ce17656